import React, { useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Typography,
  Button,
  Autocomplete,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

const initialSuggestions = [
  "Black Bows",
  "Edible Roses",
  "Gold Dust",
  "Rainbow Sprinkles",
  "Green Sprinkles",
];

const CustomizationFields = ({ customizations, onChange, onAdd, onRemove }) => {
  const [suggestions, setSuggestions] = useState(initialSuggestions);
  const [showAddConfirm, setShowAddConfirm] = useState(false);
  const [pendingSuggestion, setPendingSuggestion] = useState(null);

  const handleKeyChange = (i, value) => {
    onChange(i, "key", value);
    if (value && !suggestions.includes(value)) {
      setPendingSuggestion({ index: i, value });
      setShowAddConfirm(true);
    } else {
      setShowAddConfirm(false);
      setPendingSuggestion(null);
    }
  };

  const confirmAddSuggestion = () => {
    if (pendingSuggestion && !suggestions.includes(pendingSuggestion.value)) {
      setSuggestions((prev) => [...prev, pendingSuggestion.value]);
    }
    setShowAddConfirm(false);
    setPendingSuggestion(null);
  };

  return (
    <Box>
      <Typography variant="body2" fontWeight="bold" gutterBottom>
        Customizations
      </Typography>

      {customizations.map((c, i) => (
        <Grid container spacing={1} key={i} alignItems="center" mb={1}>
          <Grid item xs={5}>
            <Autocomplete
              freeSolo
              disableClearable
              options={suggestions}
              inputValue={c.key || ""}
              onInputChange={(_, value) => handleKeyChange(i, value)}
              onChange={(_, value) => handleKeyChange(i, value || "")}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Key"
                  fullWidth
                  placeholder="Enter customization key"
                />
              )}
            />
            {showAddConfirm && pendingSuggestion?.index === i && (
              <FormControlLabel
                control={<Checkbox onChange={confirmAddSuggestion} />}
                label={`Save "${pendingSuggestion.value}" as a future option?`}
              />
            )}
          </Grid>
          <Grid item xs={5}>
            <TextField
              label="Value"
              value={c.value}
              onChange={(e) => onChange(i, "value", e.target.value)}
              fullWidth
              placeholder="Enter customization value"
            />
          </Grid>
          <Grid item xs={2}>
            <Button color="error" onClick={() => onRemove(i)}>
              Remove
            </Button>
          </Grid>
        </Grid>
      ))}

      <Button variant="outlined" size="small" onClick={onAdd}>
        Add Customization
      </Button>
    </Box>
  );
};

export default CustomizationFields;
